import { AmpSettingDto } from "@ampsec/platform-client";
import { createSetting, getTenantSettings, updateAllSettings } from "Apis/library";
import { useApiData } from "./useApiData";
import _ from "lodash";

export const useTenantSettings = (): {
    tenantSettings: { [key: string]: AmpSettingDto };
    settingsLoading: boolean;
    refreshTenantSettings: () => void;  // refresh the tenant settings from the API
    getAmpSettingValue: (settingKey: string) => any; // get the value of an amp setting
    getAmpSettingId: (settingKey: string) => string; // get the id of an amp setting
    updateAmpSetting: (settingId: string, value: any, createIfNotExists?: boolean) => Promise<void>; // update an amp setting
    createAmpSetting: (settingId: string, value: any) => Promise<void>; // create an amp setting
    error: string | undefined;
} => {
    const { data: tenantSettings, isLoading: settingsLoading, refresh: refreshTenantSettings, error: error } =
    useApiData<{ [key: string]: AmpSettingDto }, { [key: string]: AmpSettingDto }>('TENANT_SETTINGS', getTenantSettings, (a) => a);

    const getAmpSettingValue = (settingKey: string): any => {
      if (!settingKey || (tenantSettings && _.isEmpty(tenantSettings))) {
        return true;
      }
      return tenantSettings && (tenantSettings as any)[settingKey]?.value;
    };

    const getAmpSettingId = (settingKey: string) => {
      if (!settingKey || tenantSettings === undefined || tenantSettings === null) {
          return '';
      }
      return ((tenantSettings as any)[settingKey]?.id as string) || '';
    };

    const updateAmpSetting = async (settingId: string, value: any, createIfNotExists?: boolean): Promise<void> => {
      if (!settingId) {
        throw new Error('Setting ID is required');
      }
      // Check if the setting exists
      const setting = (tenantSettings as any)[settingId];
      if (!setting && createIfNotExists) {
        return createAmpSetting(settingId, value);
      }
      await updateAllSettings([{
        id: getAmpSettingId(settingId),
        value: value,
      }]);
    };

    const createAmpSetting = async (settingId: string, value: any): Promise<void> => {
      const setting = (tenantSettings as any)[settingId];
      if (setting) {
        throw new Error('Setting already exists');
      }
      await createSetting(settingId, value);
    };

    return {
        tenantSettings: tenantSettings as { [key: string]: AmpSettingDto },
        settingsLoading,
        refreshTenantSettings,
        getAmpSettingValue,
        getAmpSettingId,
        updateAmpSetting,
        createAmpSetting,
        error
    };
};